<template>
  <div class="layout_main">
    <el-row style="height: 34px;background-color: #1F50AD;">
      <div style="width: 1200px;margin: 0 auto">
        <el-col :span="20">
          <div v-html="time" style="color: white;font-size: 14px;height: 34px;line-height: 34px"></div>
        </el-col>
<!--        <el-col :span="3" style="height: 34px" v-if="currentName">
          <div style="color: white;font-size: 14px;height: 34px;line-height: 34px;text-align: right;">{{currentName}}</div>
        </el-col>
        <el-col :span="1" :offset="2" style="height: 34px" v-else="currentName">
          <div style="color: white;font-size: 14px;height: 34px;line-height: 34px;text-align: center;cursor: pointer"
               @click="changActiveIndex(1,'login')" :class="{'index_top_active':activeIndex===1}">
            <div>登陆</div>
          </div>
        </el-col>
        <el-col :span="1" style="height: 34px" v-if="currentName">
          <div style="color: white;font-size: 14px;height: 34px;line-height: 34px;text-align: center;cursor: pointer" @click="userOut">退出</div>
        </el-col>
        <el-col :span="1" v-else="currentName">
          <div style="color: white;font-size: 14px;height: 34px;line-height: 34px;text-align: center;cursor: pointer"
               @click="changActiveIndex(2,'register')" :class="{'index_top_active':activeIndex===2}">
            <div>注册</div>
          </div>
        </el-col>-->
      </div>
    </el-row>
    <el-row style="background-color: white">
      <div style="width: 1200px;margin: 0.6% auto 0 auto;height: 72px;">
        <el-col :span="16" style="height: 108px;">
          <img style="float: left" src="../../assets/img/newIndex/logo_my.jpg" height="108px">
          <div style="height: 108px;float: left;line-height: 108px;font-size: 40px;font-family: KaiTi;color: #e30212;font-weight: 700;padding-left: 10px;">济南市历城区精神卫生防治中心</div>
        </el-col>
        <el-col :span="8" style="height: 108px;" align="right">
<!--          <img src="../../assets/img/newIndex/logo_right.png" height="72px">-->
          <div style="height: 108px;float: left;line-height: 36px;font-size: 18px;font-family: KaiTi;color: rgb(227, 2, 18);font-weight: 700;/* margin-left: -20px; */">
           <div style="text-align: left">
              值&nbsp;&nbsp;班&nbsp;电&nbsp;话：0531-82818064
              <br>
              门诊药房值班：0531-82818696
              <br>
              技&nbsp;&nbsp;术&nbsp;服&nbsp;务：13793122175</div>
          </div>
        </el-col>
      </div>
    </el-row>

    <header-view :routes="routes"></header-view>

    <main-view></main-view>
    <foot-view></foot-view>
  </div>
</template>

<script>

  import HeaderView from "../headerView/HeaderView";
  import FootView from "../headerView/footView";
  import MainView from "../mainView/MainView";
  import {constantRouterMap} from '@/router';

  export default {
    name: "Layout",
    components: {FootView, MainView, HeaderView},
    data() {
      return {
        activeIndex: 0,
        routes: constantRouterMap,
        time: '',
        userName: 'xxx'
      }
    },
    computed: {
      // 获取登录用户信息
      currentName() {
        //由于vuex的状态存储是响应式的，所以从store实例中读取状态的最简单方法就是使用计算属性来返回某个状态：
        return sessionStorage.getItem("username")
      },

    },
    methods: {
      changActiveIndex(val, router) {
        this.activeIndex = val;
        this.$router.push({name: router})
      },
      userOut:function () {
        this.$confirm('是否退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sessionStorage.clear();
          if(this.$route.path == '/news/newsRelease'){
            window.location.href = '/index';
          }else {
            window.location.reload();
          }
        })
      }
    },
    mounted() {
      let data = new Date();
      let year = data.getFullYear();
      let month = data.getMonth() + 1 >= 10 ? data.getMonth() + 1 : '0' + (data.getMonth() + 1);
      let day = data.getDate() >= 10 ? data.getDate() : '0' + data.getDate();
      let week = data.getDay();
      switch (week) {
        case 1 :
          week = "星期一";
          break;
        case 2 :
          week = "星期二";
          break;
        case 3 :
          week = "星期三";
          break;
        case 4 :
          week = "星期四";
          break;
        case 5 :
          week = "星期五";
          break;
        case 6 :
          week = "星期六";
          break;
        case 0 :
          week = "星期日";
          break;
      }
      this.time = year + '年' + month + "月" + day + '日&nbsp;&nbsp;' + week;
    }
  }
</script>

<style lang="scss">
  @import '~@/assets/style/Layout.scss';

  .index_top_active {
    background: rgba(91, 152, 223, 1);
  }


  @font-face {
    font-family: "Kimberley";
    src: url('~@/assets/iconfont/myfont.ttf') format("truetype");
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/Layout.vue